export const ADD_FAVORITE_SPEAKER = "ADD_FAVORITE_SPEAKER"
export const REMOVE_FAVORITE_SPEAKER = "REMOVE_FAVORITE_SPEAKER"
export const GET_FAVORITE_SPEAKERS = "GET_FAVORITE_SPEAKERS"
